var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lock-info" }, [
    _c("div", [_c("Icon", { attrs: { icon: "lock" } })], 1),
    _vm._v(" "),
    _c(
      "div",
      [
        _vm.$slots.default
          ? [_vm._t("default")]
          : _c("div", [_vm._v(_vm._s(_vm.defaultText))])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }